// Confetti overlay — David's celebration animation.

export default function Confetti(){
  const colors=["#ff6b6b","#ffd93d","#6bcb77","#4d96ff","#ff6bfd","#ff9f43","#a0f","#0af"];
  const pieces=Array.from({length:36},(_,i)=>({
    id:i,color:colors[i%colors.length],
    left:`${Math.random()*100}%`,
    delay:`${Math.random()*0.6}s`,
    dur:`${1.2+Math.random()*0.8}s`,
    size:7+Math.random()*9,
    shape:Math.random()>0.5?"50%":"4px"
  }));
  return(
    <div style={{position:"fixed",inset:0,pointerEvents:"none",zIndex:9999,overflow:"hidden"}}>
      {pieces.map(p=>(
        <div key={p.id} style={{
          position:"absolute",top:-20,left:p.left,
          width:p.size,height:p.size,borderRadius:p.shape,
          background:p.color,
          animation:`confettiFall ${p.dur} ${p.delay} forwards`
        }}/>
      ))}
    </div>
  );
}
